import { PROVIDER_INFO, type SessionFilters } from '@filmsloth/shared';
import { useGenreLabel, useRating, useT } from '../i18n/index.js';

/** Read-only view of what the group is picking from. */
export function FilterSummary({ filters }: { filters: SessionFilters }) {
  const t = useT();
  const genreLabel = useGenreLabel();
  const rating = useRating();

  return (
    <div className="chips">
      {filters.providers.map((provider) => (
        <span className="chip chip--static" key={provider}>
          <span className="chip__dot" style={{ background: PROVIDER_INFO[provider].color }} />
          {PROVIDER_INFO[provider].name}
        </span>
      ))}
      <span className="chip chip--static">
        {filters.genres.length === 0
          ? t('common.anyGenre')
          : filters.genres.map(genreLabel).join(', ')}
      </span>
      {filters.excludedGenres?.length ? (
        <span className="chip chip--static">
          {t('common.withoutGenres', {
            genres: filters.excludedGenres.map(genreLabel).join(', '),
          })}
        </span>
      ) : null}
      <span className="chip chip--static">
        {filters.maxRuntimeMinutes === null
          ? t('common.noLimit')
          : `≤ ${t('common.minutes', { count: filters.maxRuntimeMinutes })}`}
      </span>
      {filters.minYear != null ? (
        <span className="chip chip--static">{t('common.fromYear', { year: filters.minYear })}</span>
      ) : null}
      {filters.minRating != null ? (
        <span className="chip chip--static">
          {t('common.fromRating', { rating: rating(filters.minRating) })}
        </span>
      ) : null}
    </div>
  );
}
